export default "__VITE_ASSET__b6cc9d99__"